"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledTag = require("./StyledTag");
var _excluded = ["prefixCls", "className", "checked", "onChange", "onClick", "children", "size"];
var CheckableTag = function CheckableTag(_ref) {
  var prefixCls = _ref.prefixCls,
    className = _ref.className,
    checked = _ref.checked,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    children = _ref.children,
    size = _ref.size,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var handleClick = function handleClick(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledTag.StyledTag, (0, _extends2.default)({
      theme: theme,
      size: size,
      prefixCls: prefixCls
    }, restProps, {
      extraCls: className,
      onClick: handleClick,
      checkable: true,
      checked: checked
    }), function (styledPrefix) {
      return children;
    });
  });
};
CheckableTag.propTypes = {
  prefixCls: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func
};
CheckableTag.defaultProps = {
  closable: false,
  size: "default"
};
CheckableTag.displayName = "CheckableTag";
var _default = exports.default = (0, _inputHOC.default)(CheckableTag);